module.exports = __webpack_public_path__ + "static/media/phoneAndMessages.47368b03.svg";